import React from 'react';

function ChemwatchLinks() {
    return (
        <div className="sds-widget__item sds-widget__item--space-top">
            <a className="products-link--inverted products-icon products-icon--external products-print-expand-link"
               href="http://jr.chemwatch.net/outb/account/autologin?login=wilhelmsen"
               target="_blank">
                Direct access to all Safety Data Sheets
                <span className="visually-hidden-accessible">(new window)</span>
            </a>
            <div className="sds-widget__instruction-link">
                <a href="/ships-service/safety-data-sheets-sds-portal/" target="_blank">
                    Guidance for accessing safety data sheets
                    (SDSs) and Mini only
                </a>
            </div>
        </div>
    )
}

export default ChemwatchLinks;